import { MonitoringUsersResponse } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useTenantMonitoringUsers(tenantId: string, enabled = true) {
  const url = `/v2/orm/admin/tenants/${tenantId}/monitoring-users`;
  const request = new Request(url);

  return useAuthenticatedRequest<MonitoringUsersResponse>(request, {
    queryKey: ['admin-tenant-monitoring-users', tenantId],
    enabled,
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
  });
}

export default useTenantMonitoringUsers;
